// @ts-nocheck
export const localeCodes =  [
  "ar",
  "da",
  "de",
  "en",
  "es-419",
  "es",
  "fr",
  "it",
  "ja",
  "nl",
  "pt-PT",
  "pt"
]
export const localeLoaders = {
  ar: [
    {
      key: "locale_ar_46json_7a8a42b8",
      load: () => import("#nuxt-i18n/7a8a42b8" /* webpackChunkName: "locale_ar_46json_7a8a42b8" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_a94d829b",
      load: () => import("#nuxt-i18n/a94d829b" /* webpackChunkName: "locale_da_46json_a94d829b" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_e4f24821",
      load: () => import("#nuxt-i18n/e4f24821" /* webpackChunkName: "locale_de_46json_e4f24821" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_d68e9d5c",
      load: () => import("#nuxt-i18n/d68e9d5c" /* webpackChunkName: "locale_en_46json_d68e9d5c" */),
      cache: true
    }
  ],
  "es-419": [
    {
      key: "locale_es_45419_46json_67e30bf3",
      load: () => import("#nuxt-i18n/67e30bf3" /* webpackChunkName: "locale_es_45419_46json_67e30bf3" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_7785a05b",
      load: () => import("#nuxt-i18n/7785a05b" /* webpackChunkName: "locale_es_46json_7785a05b" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_354fc9ca",
      load: () => import("#nuxt-i18n/354fc9ca" /* webpackChunkName: "locale_fr_46json_354fc9ca" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_eb0187fc",
      load: () => import("#nuxt-i18n/eb0187fc" /* webpackChunkName: "locale_it_46json_eb0187fc" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_4c05289e",
      load: () => import("#nuxt-i18n/4c05289e" /* webpackChunkName: "locale_ja_46json_4c05289e" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_81ee0a9d",
      load: () => import("#nuxt-i18n/81ee0a9d" /* webpackChunkName: "locale_nl_46json_81ee0a9d" */),
      cache: true
    }
  ],
  "pt-PT": [
    {
      key: "locale_pt_45PT_46json_bfab7662",
      load: () => import("#nuxt-i18n/bfab7662" /* webpackChunkName: "locale_pt_45PT_46json_bfab7662" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_2f29e10f",
      load: () => import("#nuxt-i18n/2f29e10f" /* webpackChunkName: "locale_pt_46json_2f29e10f" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/fa008732" /* webpackChunkName: "config_i18n_46config_46ts_fa008732" */)
]
export const normalizedLocales = [
  {
    code: "ar",
    language: undefined
  },
  {
    code: "da",
    language: undefined
  },
  {
    code: "de",
    language: undefined
  },
  {
    code: "en",
    language: undefined
  },
  {
    code: "es-419",
    language: undefined
  },
  {
    code: "es",
    language: undefined
  },
  {
    code: "fr",
    language: undefined
  },
  {
    code: "it",
    language: undefined
  },
  {
    code: "ja",
    language: undefined
  },
  {
    code: "nl",
    language: undefined
  },
  {
    code: "pt-PT",
    language: undefined
  },
  {
    code: "pt",
    language: undefined
  }
]
/** client **/

/** client-end **/